require('jquery')
jQuery(function () {
  $(window).scroll(function () {
    if ($(window).width() > 960) {
      var scroller = $(document).scrollTop()
      var headerHeight = $('.header1').outerHeight()
      if (scroller > headerHeight) {
        $('#headerTwoHome').removeClass('d-none')
        $('#headerOneHome').addClass('d-none')
      } else {
        $('#headerTwoHome').addClass('d-none')
        $('#headerOneHome').removeClass('d-none')
      }
    }
  })
})
